<template>
    <li class="col-span-1 flex flex-col justify-between bg-white rounded-lg shadow">
        <div class="w-full flex items-center justify-between flex-grow-1 p-6 space-x-6">
            <div class="flex-1 grow">
                <div class="flex flex-wrap justify-between items-center">
                    <span
                        class="text-gray-900 mx-2 text-sm leading-5 font-semibold truncate">{{ snapshot.description_main }}</span>
                    <span v-if="snapshot.ignored"
                          class="shrink-0 inline-block px-2 my-1 py-0.5 text-gray-400 text-xs leading-4 font-normal">
                        Ignored {{ snapshot.user ? 'by ' + snapshot.user.display_name : '' }}
                    </span>
                    <span v-else
                          class="flex-grow-1 inline-block px-2 my-1 py-0.5 text-yellow-800 bg-yellow-100 rounded-full text-xs leading-4 font-normal">
                        Issue Identified
                    </span>
                </div>
                <p class="mt-2 ml-2 text-gray-500 text-sm font-normal leading-5 break-normal">
                    {{ snapshot.description_secondary }}</p>
            </div>
        </div>
        <div v-if="snapshot.issue && permissions.can('resolve_snapshot')" class="border-t border-gray-200">
            <div class="-mt-px flex">
                <div class="w-0 flex-1 flex border-r border-gray-200">
                    <a :href="snapshot.fix_link"
                       class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10 plain-link">
                        <span class="lnr icon-wrench"></span>
                        <span class="ml-3">Fix</span>
                    </a>
                </div>
                <div v-if="snapshot.ignored" class="-ml-px w-0 flex-1 flex">
                    <a @click.prevent="unignoreSnapshot"
                       href="#"
                       class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10 plain-link cursor-pointer">
                        <span class="lnr icon-play-circle"></span>
                        <span class="ml-3">Unignore</span>
                    </a>
                </div>
                <div v-else class="-ml-px w-0 flex-1 flex">
                    <a @click.prevent="ignoreSnapshot"
                       class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10 plain-link cursor-pointer">
                        <span class="lnr icon-pause-circle"></span>
                        <span class="ml-3">Ignore</span>
                    </a>
                </div>
            </div>
        </div>
        <div v-else-if="permissions.can('resolve_snapshot')" class="border-t border-gray-200">
            <div class="-mt-px flex">
                <div class="w-0 flex-1 flex border-r border-gray-200">
                    <a href="#"
                       class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10 plain-link">
                        <span class="lnr icon-check"></span>
                        <span class="ml-3">No problems!</span>
                    </a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import axios from 'axios';
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

export default {
    name: "SnapshotInstance",
    mixins: [SonicuCoreMixin],
    props: {
        snapshot: Object,
    },
    created() {
    },
    data() {
        return {}
    },
    methods: {
        ignoreSnapshot() {
            this.updateSnapshot(true);
        },
        unignoreSnapshot() {
            this.updateSnapshot(false);
        },
        updateSnapshot(ignore) {
            axios
                .put(this.company.buildCompanyApiInternalRoute('snapshot/' + this.snapshot.id), {
                    'ignored': ignore,
                })
                .then(response => {
                    this.$emit('update:snapshot', response.data)
                    // this.setRefresh(); // Refresh this info on a set interval
                });
        }
    },
}
</script>

<style scoped>

</style>